module.exports = __webpack_public_path__ + "img/certificado_assinatura.fb82b861.svg";